// Mock data for gas IoT gateways
export const mockIoTGateways = [
  {
    deviceId: "GASGW001",
    location: "Building A, Server Room",
    status: "Healthy",
    connectedDevices: 24,
    uptimeHours: 2184,
    cpuUsage: 32,
    memoryUsage: 45,
    temperatureCelsius: 38.5,
    firmwareVersion: "v2.9.3",
    networkStatus: {
      connectivityType: "Ethernet",
      signalStrength: 95,
      dataTransferred: 1458.7,
      lastPingTime: 23
    },
    maintenanceStatus: {
      lastMaintenance: "2025-01-10",
      nextScheduled: "2026-01-20", 
      alerts: []
    }
  },
  {
    deviceId: "GASGW002",
    location: "Building B, Utility Room",
    status: "Warning",
    connectedDevices: 18,
    uptimeHours: 1056,
    cpuUsage: 67,
    memoryUsage: 82,
    temperatureCelsius: 55.3,
    firmwareVersion: "v2.9.2",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 72,
      dataTransferred: 982.3,
      lastPingTime: 48
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-10",
      nextScheduled: "2026-02-10", 
      alerts: ["High temperature warning", "Memory usage high"]
    }
  },
  {
    deviceId: "GASGW003",
    location: "Building C, Electrical Room",
    status: "Critical",
    connectedDevices: 5,
    uptimeHours: 38,
    cpuUsage: 95,
    memoryUsage: 94,
    temperatureCelsius: 68.7,
    firmwareVersion: "v2.8.5",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 34,
      dataTransferred: 148.2,
      lastPingTime: 235
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-15",
      nextScheduled: "2026-01-15", 
      alerts: ["Critical temperature", "Connectivity issues", "CPU overload", "Maintenance overdue"]
    }
  },
  {
    deviceId: "gw-3045",
    location: "Building F, Utility Room",
    status: "Warning",
    connectedDevices: 15,
    uptimeHours: 1256,
    cpuUsage: 54,
    memoryUsage: 72,
    temperatureCelsius: 51.4,
    firmwareVersion: "v2.9.1",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 67,
      dataTransferred: 823.6,
      lastPingTime: 42
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-25",
      nextScheduled: "2026-01-25", 
      alerts: ["Battery degradation detected"]
    }
  },
  {
    deviceId: "vr-2034",
    location: "Building G, Monitoring Station",
    status: "Warning",
    connectedDevices: 7,
    uptimeHours: 945,
    cpuUsage: 61,
    memoryUsage: 68,
    temperatureCelsius: 49.8,
    firmwareVersion: "v2.8.9",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 70,
      dataTransferred: 543.2,
      lastPingTime: 36
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-12",
      nextScheduled: "2026-02-12", 
      alerts: ["Performance degradation"]
    }
  }
];
